import ApplicationForm from "@/components/ApplicationForm";
import { useSeo } from "@/hooks/useSeo";

const BRANCHES = ["Army", "Marine Corps", "Navy", "Air Force", "Space Force", "Coast Guard", "National Guard", "Reserves"];

export default function VeteranApplication() {
  useSeo("Veteran Service-Dog Application", "Apply to the Golden Wolf Service Dog Program. A secure, privacy-conscious application for veterans in need of a service dog.");
  return (
    <ApplicationForm
      overline="Service Dog Program"
      title="Veteran Application"
      sub="A confidential, privacy-first inquiry. We only ask what we need for initial screening."
      endpoint="/applications/veteran"
      note="Submitting an application does not guarantee acceptance or placement. You will never be asked to publish a diagnosis. Sensitive verification documents are requested securely only at a later stage, and access is restricted to authorized administrators."
      consentLabel="I understand that submitting this application does not guarantee acceptance or placement."
      fields={[
        { name: "name", label: "Full name", required: true, half: true },
        { name: "email", label: "Email", type: "email", required: true, half: true },
        { name: "phone", label: "Phone", type: "tel", half: true },
        { name: "preferred_contact", label: "Preferred contact method", type: "select", options: ["Email", "Phone", "Text"], half: true },
        { name: "city", label: "City", half: true },
        { name: "state", label: "State", half: true },
        { name: "branch", label: "Branch of service", type: "select", options: BRANCHES, half: true },
        { name: "service_dates", label: "Service dates (optional)", half: true },
        { name: "assistance_goals", label: "General assistance goals", type: "textarea", placeholder: "What kind of daily support are you hoping a service dog could provide?" },
        { name: "current_dog_ownership", label: "Do you currently own a dog?", type: "select", options: ["No", "Yes"], half: true },
        { name: "can_participate_training", label: "Able to participate in training?", type: "select", options: ["Yes", "Some limitations", "Unsure"], half: true },
        { name: "housing_considerations", label: "Housing considerations", type: "textarea", placeholder: "Any housing details relevant to a service dog (rentals, restrictions, space)." },
        { name: "referral_source", label: "How did you hear about us?", half: true },
      ]}
    />
  );
}
